import { Layers, GitCompareArrows, Link2, Eye, ShoppingBag, Crosshair } from "lucide-react";
import { SectionHead, Reveal } from "./shared";

const ITEMS = [
  { icon: Layers, title: "Gestão por lotes com rastreabilidade", desc: "Cada lote carrega sua história: custo, preços, remarcações, vendas e margem final. Nada se perde no caminho.", span: "lg:col-span-2" },
  { icon: GitCompareArrows, title: "Projetado × Realizado × Potencial", desc: "Três visões separadas com clareza — o plano, o fato e a oportunidade ainda em aberto.", span: "" },
  { icon: Link2, title: "Margem integrada à operação real", desc: "A margem não é estimativa de fim de mês: ela se move junto com cada venda e cada remarcação.", span: "" },
  { icon: Eye, title: "Visão clara de custos, margem e faturamento", desc: "Os três eixos do negócio em uma única tela, sem planilhas paralelas nem cruzamentos manuais.", span: "lg:col-span-2" },
  { icon: ShoppingBag, title: "Apoio a decisões de compra, preço e remarcação", desc: "Quanto pagar, quanto cobrar e até onde descontar — com o impacto calculado antes da decisão.", span: "" },
  { icon: Crosshair, title: "Ponto de equilíbrio e resultado em um só lugar", desc: "O momento exato em que o negócio começa a gerar lucro, visível todos os dias.", span: "lg:col-span-2" },
];

export const Differentials = () => (
  <section id="diferenciais" data-testid="differentials-section" className="relative bg-tria-navy/50 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Diferenciais"
        testId="differentials-head"
        title={<>Por que a TRIA é <span className="text-gradient-blue">diferente</span></>}
        sub="Não é mais um sistema de vendas. É uma plataforma de inteligência gerencial construída sobre um método próprio."
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.06} className={item.span}>
            <div
              data-testid={`differential-card-${i + 1}`}
              className="group relative h-full overflow-hidden rounded-2xl border border-white/[0.07] bg-white/[0.02] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-tria-sky/30 hover:bg-gradient-to-br hover:from-tria-vivid/[0.08] hover:to-transparent"
            >
              <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-tria-blue/0 blur-2xl transition-all duration-500 group-hover:bg-tria-blue/15" />
              <span className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-tria-vivid/25 to-tria-sky/10 text-tria-sky transition-transform duration-300 group-hover:scale-110">
                <item.icon className="h-5 w-5" />
              </span>
              <h3 className="font-display text-[17px] font-semibold leading-snug text-white">{item.title}</h3>
              <p className="mt-2.5 text-[13.5px] leading-relaxed text-tria-mist">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
